import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from "@react-navigation/native";
import {
  Button,
  PartialPage,
  View,
  Text,
  useThemeProvider,
  Page,
  VStack,
  Banner,
} from "@towersystems/roam-common-native";
import { keys } from "../../../../../../utilities/i18n";
import { useTranslation } from "react-i18next";
import { InteractionManager } from "react-native";
import { useSelectUploadImageProvider } from "../../../../../photo-image/components/SelectUploadImageProvider/hooks";
import { useImagesSentSuccessProvider } from "../../../../../photo-image/components/ImagesSentSuccessProvider/hooks";
import { AntDesign } from "@expo/vector-icons";
import { ScannedBarcodeFormatBanner } from "../../../../components";
import { useCallback } from "react";

export interface RetailerOnlyScannedPartialScreenProps {}

export function RetailerOnlyScannedPartialScreen(
  props: RetailerOnlyScannedPartialScreenProps
) {
  const navigation = useNavigation<any>();
  const route = useRoute<any>();
  const { colors, spacings } = useThemeProvider();
  const { t } = useTranslation();

  const { updateHandlers: updateSelectUploadImageHandlers } =
    useSelectUploadImageProvider();
  const { updateHandlers: updateImagesSentSuccessHandlers } =
    useImagesSentSuccessProvider();

  const {
    params: { sku, format },
  } = route;

  function handleTakeRetailerPhoto() {
    navigation.goBack();

    InteractionManager.runAfterInteractions(() => {
      navigation.navigate("PhotoImageRootScreen", {
        screen: "SelectUploadRetailerImageMethodScreen",
        params: {
          sku: sku,
        },
      });
    });
  }

  function handleScanAgain() {
    navigation.goBack();
  }

  useFocusEffect(
    useCallback(() => {
      updateSelectUploadImageHandlers({
        onUpload: () => undefined,
      });

      updateImagesSentSuccessHandlers({
        onTakeMore: (nav) => nav.goBack(),
        onNewProduct: (nav) => nav.pop(2),
        onFinished: (nav) => nav.pop(3),
      });
    }, [updateSelectUploadImageHandlers, updateImagesSentSuccessHandlers])
  );

  const footer = (
    <VStack spacing={spacings.s2}>
      <Button
        style={{
          display: "flex",
        }}
        label={t(keys.takePhoto)}
        onPress={handleTakeRetailerPhoto}
        color={colors.textOnPrimary}
        backgroundColor={colors.primary}
      />
      <Button
        variant="outline"
        style={{
          display: "flex",
        }}
        label={t(keys.scanAgain)}
        onPress={handleScanAgain}
        color={colors.text}
        backgroundColor={colors.primary}
      />
    </VStack>
  );

  return (
    <PartialPage
      scrollable={false}
      size="compact"
      onClose={() => navigation.goBack()}
      contentContainerStyle={{ flex: 1 }}
    >
      <Page
        footerStyles={{ padding: 0, borderTopWidth: 0 }}
        scrollable
        cover
        padding={0}
        footer={footer}
      >
        <View flex>
          <VStack>
            <ScannedBarcodeFormatBanner format={format} />
            <View>
              <Text
                variant="heading"
                fontWeight="medium"
                numberOfLines={5}
                ellipsizeMode="head"
              >
                {t(keys.noProductFoundScanned, { sku: sku })}
              </Text>
              <Text variant="heading3" color="subdued">
                {t(keys.stockCodeWarning)}
              </Text>
            </View>
          </VStack>
        </View>
      </Page>
    </PartialPage>
  );
}
